import { useNavigate, useLocation } from 'react-router-dom';
import { IconButton } from '@mui/material';
import  ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FC } from 'react';

interface BackButtonProps {
  /**
   * Ruta alternativa a la que navegar al hacer clic
   * Si no se proporciona, navegará a la página anterior (-1)
   */
  customPath?: string;
  /**
   * Posición fija del botón
   * @default true
   */
  fixed?: boolean;
}

const BackButton: FC<BackButtonProps> = ({ customPath, fixed = true }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // No mostrar el botón en la página principal
  const isHomePage = location.pathname === '/';
  const isWelcome = location.pathname === '/bienvenida' || location.pathname === '/terminos' || location.pathname === '/subscription'
  if (isHomePage) return null;

  const handleClick = () => {
    if (customPath) {
      navigate(customPath);
    } else {
      navigate(-1);
    }
  };

  return (<>
      <br/>
    <IconButton
      onClick={handleClick}
      sx={{
        position: fixed ? 'fixed' : 'absolute',
        top: 16,
        left: 16,
        zIndex: 1000,
        backgroundColor: 'background.paper',
        boxShadow: 1,
        '&:hover': {
          backgroundColor: 'action.hover',
        }
      }}
      aria-label="Volver atrás"
      size="large"
      disabled={isWelcome}
      hidden={isWelcome}
    >
        <ArrowBackIcon fontSize={"small"}  />

    </IconButton>
      </>
  );
};

export default BackButton;